import { PaginationComponent } from 'components/common';
import { useDispatch, useSelector } from 'react-redux';
import { selectPagination, setPage } from 'ducks/booking';
import React from 'react';

const Pagination = (props: unknown) => {
    const dispatch = useDispatch();
    const pagination = useSelector(selectPagination);

    const handleSetPage = (page: number) => {
        dispatch(setPage({ page }));
    };

    return (
        <PaginationComponent
            {...props}
            pagination={pagination}
            setPage={handleSetPage}
        />
    );
};

export default Pagination;
